export enum FileTypeSchemaType {
  object = 'object',
  list = 'list',
  string = 'string',
  int = 'int',
  float = 'float',
  boolean = 'boolean',
  unknown = 'unknown'
}
